import { render, staticRenderFns } from "./VLANs.vue?vue&type=template&id=1bfe976b&"
import script from "./VLANs.vue?vue&type=script&lang=js&"
export * from "./VLANs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports